module.exports = __webpack_public_path__ + "img/icon-biddog_library.bc1ed795.png";